module.exports = "https://cdn-social.hiplatform.com/images/659ad5977b2b8f23befbac76936a3213.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/horizon.jpg
// module id = /C7i
// module chunks = 0